import React from 'react'
import './Button.css';
import by5logo from './logo-color.png';

function Button() {

  return (
    <div className="centerContainer">
      <a href="https://www.linkedin.com/in/bruceyim/" target="_blank">
        <img src={by5logo} className="by5logo" alt="BY5 Logo" />
      </a>

      <div className="buttonContainer">
        <a href={process.env.PUBLIC_URL + "/Chilam_Yim_Resume_3.pdf"} download>
          <strong className="buttonText">DOWNLOAD MY RESUME HERE</strong>
        </a>
      </div>

     
    </div>
  );
}

export default Button